// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__32_-a","CloseModal":"Modal__CloseModal__3pcFp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 108
// module chunks = 0